import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound   from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck     from '@/components/common/PermissionCheck';

/**
 * Chef DataTable
 * ─────────────────────────────────────────────────────────
 * • Keeps the same props contract the Employees table used
 *   so <ChefsPage /> doesn’t need edits.
 * •   – View / Edit / Delete actions now point to “chefs”
 *       routes instead of “employees”.
 * • Uses the same employee-level permissions for now
 *   (update_employees, delete_employees).  If you later add
 *   chef-specific permissions, just change the strings here.
 */
const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
}) => (
  <TableWrapServerSide
    tableColumnList={tableColumn}
    totalDataCount={totalRecord}
    initialPage={dataFilter?.page}
    onChangePage={onChangePage}
    per_page={dataFilter?.limit}
  >
    {dataSource.length ? (
      dataSource.map((chef) => (
        <tr className="db-table-body-tr" key={chef._id}>
          <td className="db-table-body-td">{chef.name}</td>
          <td className="db-table-body-td">{chef.email}</td>
          <td className="db-table-body-td">{chef.phone_no}</td>
          <td className="db-table-body-td">{chef?.role_id?.name}</td>
          <td className="db-table-body-td">
            {chef.status === 1 ? (
              <span className="active">Active</span>
            ) : (
              <span className="inactive">Inactive</span>
            )}
          </td>
          <td className="db-table-body-td">{chef.salary}</td>
          <td className="db-table-body-td hidden-print hidden-print-remove">
            <div className="flex items-center gap-1.5">
              {/* ── View Chef ───────────────────────────────── */}
              <PermissionCheck permsission="view_employees">
                <Link
                  to={`/admin/chefs/show/${chef._id}`}
                  className="db-table-action view"
                  state={{ chef }}
                >
                  <i className="lab lab-view" />
                  <span className="db-tooltip">view</span>
                </Link>
              </PermissionCheck>

              {/* ── Edit Chef ──────────────────────────────── */}
              <PermissionCheck permsission="update_employees">
                <button
                  data-modal="#sidebar"
                  className="db-table-action edit"
                  onClick={() => handleDrawerOpen(chef._id)}
                >
                  <i className="lab lab-edit-line" />
                  <span className="db-tooltip">edit</span>
                </button>
              </PermissionCheck>

              {/* ── Delete Chef ────────────────────────────── */}
              <PermissionCheck permsission="delete_employees">
                <button
                  className="db-table-action delete"
                  onClick={() => deleteRecord(chef._id)}
                >
                  <i className="lab lab-delete" />
                  <span className="db-tooltip">delete</span>
                </button>
              </PermissionCheck>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
    )}
  </TableWrapServerSide>
);

export default DataTable;
